import { useSetAtom } from "jotai";
import { useEffect } from "react";
import {
  chatSuppressionsAtom,
  withoutSuppression,
  withSuppression,
} from "../domain/chat/state";
import { useDomId } from "../themeV2";

export default function useSuppressChat(active) {
  const id = useDomId("chat-suppressor");
  const setSuppressions = useSetAtom(chatSuppressionsAtom);

  useEffect(() => {
    if (!active) return undefined;
    setSuppressions(withSuppression(id));
    return () => setSuppressions(withoutSuppression(id));
  }, [active, id, setSuppressions]);
}
